// Icon of a response option, in the colour and icon the option was given (US 9398). Options saved before
// colours and icons existed look like what they count as (Positive, Negative, Neutral or a risk level).
import { optionStyle } from '@/util/dropdownOptions.js';

export function iconForOption(option) {
  if (!option || !option.value) {
    return null;
  }
  const style = optionStyle(option);
  return { icon: style.icon, style: { color: style.text || style.hex } };
}

// The icon of a task's response, looked up in the task's response options
export function responseIcon(optionsJson, title) {
  if (!optionsJson || !title) {
    return null;
  }
  let options = [];
  try {
    options = typeof optionsJson === 'string' ? JSON.parse(optionsJson) : optionsJson;
  } catch (e) {
    return null;
  }
  return iconForOption(_.find(options || [], item => item.title === title));
}
